/*
 *
 * XpayBackOfficePopup
 *
 * @version 1.0.0
 * @author Ivana Piscitelli
 * @since 10-Apr-2025
*/

import XpayBackOfficePopup from './XpayBackOfficePopupContainer'

export default XpayBackOfficePopup
